import React from "react";
import { ArrowDownRight, ArrowUpRight, Minus } from "lucide-react";
import Sparkline from "@/components/shownotes/Sparkline";
import { fmtClock } from "@/components/shownotes/meta";

const TREND = {
  faster: { cls: "bg-emerald-50 text-emerald-700 border-emerald-200", Icon: ArrowDownRight, color: "#059669", word: "faster" },
  slower: { cls: "bg-rose-50 text-rose-700 border-rose-200", Icon: ArrowUpRight, color: "#e11d48", word: "slower" },
  steady: { cls: "bg-slate-50 text-slate-600 border-slate-200", Icon: Minus, color: "#64748b", word: "steady" },
};

function ChangeChip({ s, i }) {
  if (!s.trend) return <span className="text-xs text-slate-400" data-testid={`scene-trend-chip-${i}`}>Needs 2+ runs</span>;
  const t = TREND[s.trend];
  const amount = s.trend === "steady" ? "Steady" : `${s.change > 0 ? "+" : "−"}${fmtClock(Math.abs(s.change))} ${t.word}`;
  return (
    <span className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-semibold ${t.cls}`}
      title={`Avg of first ${s.compare_runs} run(s): ${fmtClock(s.first_avg)} → last ${s.compare_runs}: ${fmtClock(s.last_avg)}`} data-testid={`scene-trend-chip-${i}`}>
      <t.Icon className="h-3.5 w-3.5" /> {amount}
    </span>
  );
}

// One scene: name + run count, sparkline of every run, average, first-vs-last change.
export default function SceneTrendRow({ s, i }) {
  return (
    <div className="grid grid-cols-[1fr_auto] items-center gap-3 border-b border-slate-100 py-3 last:border-0 sm:grid-cols-[1fr_8rem_6rem_10rem]" data-testid={`scene-trend-row-${i}`}>
      <div className="order-1 min-w-0">
        <p className="truncate font-medium text-slate-900" data-testid={`scene-trend-name-${i}`}>{s.name}</p>
        <p className="text-[11px] text-slate-400">{s.runs} run{s.runs === 1 ? "" : "s"}</p>
      </div>
      <div className="order-3 sm:order-2"><Sparkline points={s.points} color={TREND[s.trend || "steady"].color} testId={`scene-trend-spark-${i}`} /></div>
      <p className="order-2 text-right font-semibold tabular-nums text-slate-900 sm:order-3" data-testid={`scene-trend-avg-${i}`}>{fmtClock(s.average)}</p>
      <div className="order-4 text-right"><ChangeChip s={s} i={i} /></div>
    </div>
  );
}
